import {
    Accordion,
    Box,
    Flex,
    Icon,
    Image,
    Link,
    Spinner,
    Stack,
    Text,
    useBreakpointValue,
} from "@chakra-ui/react";
import { ArrowLeftIcon, CaretRightIcon, ListIcon } from "@phosphor-icons/react/dist/ssr";
import { useState } from "react";

import { useGetDevelopmentSelection2dQuery } from "@/hooks/microservicesApi";

import ContentSelection from "./Content-Selection";

const Seleccion = ({ developmentData, setIsInit }) => {
    const { data: developmentData2D } = useGetDevelopmentSelection2dQuery(developmentData?.id);
    const [options, setOptions] = useState([]);
    const [towersOptions, setOptionsTowers] = useState(null);
    const [viewSelected, setViewSelected] = useState(null);
    const [step, setStep] = useState(1);
    const isGreaterThanMd = useBreakpointValue({ base: false, md: true });
    const [showMenu, setShowMenu] = useState(false);

    const capitalizeWords = (str) => {
        return str
            .toLowerCase() // Convierte todo a minúsculas
            .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitaliza la primera letra de cada palabra
    };

    return (
        <>
            {!isGreaterThanMd && step == 1 ? (
                <Box
                    minHeight="98vh"
                    maxH="100%"
                    bg={
                        developmentData?.branding_props?.brand_sidebar ||
                        developmentData?.branding_props?.brand ||
                        "#002B49"
                    }
                    rounded="2xl"
                    alignContent="center"
                    justifyItems="center"
                    w="100%"
                >
                    <Flex direction="column" align="center" gap={8} w="90%" m="auto">
                        <Image
                            alt="logo"
                            src={
                                developmentData?.branding_props?.logo_sidebar ||
                                developmentData?.branding_props?.logo
                            }
                            minW="30vw"
                            maxW="40vw"
                            mt="3vh"
                        />

                        <Stack
                            maxH="50vh"
                            minH="50vh"
                            w="100%"
                            alignItems="end"
                            overflowY={options.length > 3 ? "scroll" : "hidden"}
                        >
                            {towersOptions && towersOptions.length > 1 ? (
                                <Accordion.Root collapsible w="100%">
                                    {towersOptions.map((tower, index) => {
                                        return (
                                            <Accordion.Item key={index} value={tower}>
                                                <Accordion.ItemTrigger
                                                    color={
                                                        developmentData?.branding_props
                                                            ?.sidebar_brand_text || "#FFFFFF"
                                                    }
                                                    borderTopWidth="0.5px"
                                                    borderBottomWidth={
                                                        index == towersOptions.length - 1
                                                            ? "0.5px"
                                                            : 0
                                                    }
                                                    borderColor={
                                                        developmentData?.branding_props
                                                            ?.sidebar_brand_text || "#FFFFFF"
                                                    }
                                                >
                                                    <Box
                                                        key={tower}
                                                        bg="transparent"
                                                        px={6}
                                                        w="100%"
                                                        cursor="pointer"
                                                        m={0}
                                                        mt={0}
                                                        style={{ marginTop: 0 }}
                                                        flex="1"
                                                        textAlign="left"
                                                    >
                                                        <Text
                                                            color={
                                                                developmentData?.branding_props
                                                                    ?.sidebar_brand_text ||
                                                                "#FFFFFF"
                                                            }
                                                            fontSize={
                                                                developmentData?.branding_props
                                                                    ?.font_size_sideboard
                                                                    ? developmentData
                                                                          ?.branding_props
                                                                          ?.font_size_sideboard
                                                                    : "2vh"
                                                            }
                                                            fontWeight={700}
                                                            fontFamily={
                                                                developmentData?.branding_props
                                                                    ?.title_font ||
                                                                developmentData?.branding_props
                                                                    .primary_font ||
                                                                "Montserrat"
                                                            }
                                                            textTransform="uppercase"
                                                            m={0}
                                                            py={8}
                                                            maxW="80%"
                                                        >
                                                            {capitalizeWords(tower)}
                                                        </Text>
                                                    </Box>
                                                    <Accordion.ItemIndicator />
                                                </Accordion.ItemTrigger>
                                                <Accordion.ItemContent>
                                                    <Accordion.ItemBody
                                                        p={0}
                                                        borderColor="transparent"
                                                    >
                                                        {options
                                                            ?.filter(
                                                                (option) => option.tower == tower
                                                            )
                                                            .map((option_, index) => {
                                                                return (
                                                                    <Box
                                                                        key={option_?.name_option}
                                                                        bg={
                                                                            developmentData
                                                                                ?.branding_props
                                                                                ?.sidebar_brand_text ||
                                                                            "#FFFFFF"
                                                                        }
                                                                        px={6}
                                                                        w="100%"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            setStep(2);
                                                                            setViewSelected(
                                                                                option_
                                                                            );
                                                                        }}
                                                                        cursor="pointer"
                                                                        borderTopWidth="0.5px"
                                                                        borderBottomWidth={
                                                                            index ==
                                                                            options.length - 1
                                                                                ? "0.5px"
                                                                                : 0
                                                                        }
                                                                        borderBottomRadius={
                                                                            options?.filter(
                                                                                (option) =>
                                                                                    option.tower ==
                                                                                    tower
                                                                            ).length ==
                                                                            index + 1
                                                                                ? "2xl"
                                                                                : 0
                                                                        }
                                                                        borderColor="#F1F1F1"
                                                                        m={0}
                                                                        mt={0}
                                                                        style={{ marginTop: 0 }}
                                                                    >
                                                                        <Flex
                                                                            alignItems="center"
                                                                            justifyContent="space-between"
                                                                        >
                                                                            <Text
                                                                                color={
                                                                                    developmentData
                                                                                        ?.branding_props
                                                                                        ?.brand_sidebar ||
                                                                                    developmentData
                                                                                        ?.branding_props
                                                                                        ?.brand ||
                                                                                    "#002B49"
                                                                                }
                                                                                fontSize={
                                                                                    developmentData
                                                                                        ?.branding_props
                                                                                        ?.font_size_sideboard
                                                                                        ? developmentData
                                                                                              ?.branding_props
                                                                                              ?.font_size_sideboard
                                                                                        : "2vh"
                                                                                }
                                                                                fontWeight={700}
                                                                                fontFamily={
                                                                                    developmentData
                                                                                        ?.branding_props
                                                                                        ?.title_font ||
                                                                                    developmentData
                                                                                        ?.branding_props
                                                                                        .primary_font ||
                                                                                    "Montserrat"
                                                                                }
                                                                                textTransform="uppercase"
                                                                                m={0}
                                                                                py={8}
                                                                                maxW="80%"
                                                                            >
                                                                                {capitalizeWords(
                                                                                    option_?.name_option.replace(
                                                                                        `${tower} /`,
                                                                                        ""
                                                                                    )
                                                                                )}
                                                                            </Text>
                                                                            <Icon
                                                                                color={
                                                                                    developmentData
                                                                                        ?.branding_props
                                                                                        ?.sidebar_brand_text ||
                                                                                    "#FFFFFF"
                                                                                }
                                                                                fontSize={
                                                                                    developmentData
                                                                                        ?.branding_props
                                                                                        ?.font_size_sideboard
                                                                                        ? developmentData
                                                                                              ?.branding_props
                                                                                              ?.font_size_sideboard
                                                                                        : "2vh"
                                                                                }
                                                                                fontWeight={700}
                                                                            >
                                                                                <CaretRightIcon weight="bold" />
                                                                            </Icon>
                                                                        </Flex>
                                                                    </Box>
                                                                );
                                                            })}
                                                    </Accordion.ItemBody>
                                                </Accordion.ItemContent>
                                            </Accordion.Item>
                                        );
                                    })}
                                </Accordion.Root>
                            ) : (
                                options.map((option, index) => {
                                    return (
                                        <Box
                                            key={option.name_option}
                                            bg="transparent"
                                            px={6}
                                            w="100%"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setStep(2);
                                                setViewSelected(option);
                                            }}
                                            cursor="pointer"
                                            borderTopWidth="0.5px"
                                            borderBottomWidth={
                                                index == options.length - 1 ? "0.5px" : 0
                                            }
                                            borderColor="#F1F1F1"
                                            m={0}
                                            mt={0}
                                            style={{ marginTop: 0 }}
                                        >
                                            <Flex
                                                alignItems="center"
                                                justifyContent="space-between"
                                            >
                                                <Text
                                                    color={
                                                        developmentData?.branding_props
                                                            ?.sidebar_brand_text || "#FFFFFF"
                                                    }
                                                    fontSize={
                                                        developmentData?.branding_props
                                                            ?.font_size_sideboard
                                                            ? developmentData?.branding_props
                                                                  ?.font_size_sideboard
                                                            : "2vh"
                                                    }
                                                    fontWeight={700}
                                                    fontFamily={
                                                        developmentData?.branding_props
                                                            ?.options_font ||
                                                        developmentData?.branding_props
                                                            ?.title_font ||
                                                        developmentData?.branding_props
                                                            .primary_font ||
                                                        "Montserrat"
                                                    }
                                                    textTransform="uppercase"
                                                    m={0}
                                                    py={8}
                                                    maxW="80%"
                                                >
                                                    {capitalizeWords(option.name_option)}
                                                </Text>
                                                <Icon
                                                    color={
                                                        developmentData?.branding_props
                                                            ?.sidebar_brand_text || "#FFFFFF"
                                                    }
                                                    fontSize={
                                                        developmentData?.branding_props
                                                            ?.font_size_sideboard
                                                            ? developmentData?.branding_props
                                                                  ?.font_size_sideboard
                                                            : "2vh"
                                                    }
                                                    fontWeight={700}
                                                >
                                                    <CaretRightIcon />
                                                </Icon>
                                            </Flex>
                                        </Box>
                                    );
                                })
                            )}
                        </Stack>
                        <Stack>
                            <Stack align="center" mb={4}>
                                <Icon
                                    color={
                                        developmentData?.branding_props?.arrow_color_sidebar
                                            ? developmentData?.branding_props?.arrow_color_sidebar
                                            : developmentData?.branding_props?.arrow_color ||
                                              developmentData?.branding_props?.sidebar_brand_text ||
                                              developmentData?.branding_props?.brand_text ||
                                              "#FFFFFF"
                                    }
                                    fontSize="4vh"
                                    cursor="pointer"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setIsInit(false);
                                    }}
                                    _hover={{
                                        color: developmentData?.branding_props?.arrow_color
                                            ? developmentData?.branding_props?.arrow_color
                                            : developmentData?.branding_props?.sidebar_brand_text ||
                                              developmentData?.branding_props?.accent ||
                                              "#F1F1F1",
                                        transform: "scale(1.1)",
                                    }}
                                >
                                    <ArrowLeftIcon />
                                </Icon>
                            </Stack>
                            <Flex gap={6} justifyContent="space-evenly">
                                <Stack align="center" paddingBottom={1}>
                                    <Text
                                        color={
                                            developmentData?.branding_props
                                                ?.sidebar_copy_brand_text ||
                                            developmentData?.branding_props?.sidebar_brand_text ||
                                            developmentData?.branding_props?.brand_text ||
                                            "#FFFFFF"
                                        }
                                        fontSize="0.9vh"
                                        fontWeight={400}
                                        paddingBottom={1}
                                    >
                                        Desarrollado por
                                    </Text>
                                    <Image
                                        alt="logo"
                                        src={
                                            developmentData?.branding_props
                                                ?.logo_developer_sidebar ||
                                            developmentData?.branding_props?.logo_developer
                                        }
                                        maxH="5vh"
                                        maxW="20vw"
                                        paddingBottom={1}
                                    />
                                </Stack>
                                <Stack align="center" paddingBottom={1}>
                                    <Text
                                        color={
                                            developmentData?.branding_props
                                                ?.sidebar_copy_brand_text ||
                                            developmentData?.branding_props?.sidebar_brand_text ||
                                            developmentData?.branding_props?.brand_text ||
                                            "#FFFFFF"
                                        }
                                        fontSize="0.9vh"
                                        fontWeight={400}
                                        paddingBottom={2}
                                    >
                                        Comercializado por
                                    </Text>
                                    <Image
                                        alt="logo"
                                        src={
                                            developmentData?.branding_props?.logo_broker_sidebar ||
                                            "https://media.grupoguia.mx/vision/logo/grupo-guia.svg"
                                        }
                                        maxH="5vh"
                                        maxW="20vw"
                                    />
                                </Stack>
                            </Flex>
                            <Stack align="center" textAlign="center">
                                <Text
                                    color={
                                        developmentData?.branding_props?.sidebar_copy_brand_text ||
                                        developmentData?.branding_props?.sidebar_brand_text ||
                                        developmentData?.branding_props?.brand_text ||
                                        "#FFFFFF"
                                    }
                                    fontSize="0.9vh"
                                    fontWeight={400}
                                    px={2}
                                >
                                    Copyright © 2025 © All Rights Reserved - Powered by Grupo guia
                                    <br />
                                    <Link
                                        href="/Aviso-de-privacidad"
                                        style={{
                                            color:
                                                developmentData?.branding_props
                                                    ?.sidebar_copy_brand_text ||
                                                developmentData?.branding_props
                                                    ?.sidebar_brand_text ||
                                                developmentData?.branding_props?.brand_text ||
                                                "#FFFFFF",
                                            fontSize: "1vh",
                                        }}
                                    >
                                        Aviso de privacidad
                                    </Link>
                                </Text>
                            </Stack>
                            <Stack display="none">
                                {developmentData2D && (
                                    <ContentSelection
                                        developmentData={developmentData}
                                        data={developmentData2D}
                                        options={options}
                                        setOptions={setOptions}
                                        viewSelected={viewSelected}
                                        setViewSelected={setViewSelected}
                                        setOptionsTowers={setOptionsTowers}
                                    />
                                )}
                            </Stack>
                        </Stack>
                    </Flex>
                </Box>
            ) : (
                <Box
                    minHeight="98vh"
                    maxH="100%"
                    bg={
                        developmentData?.branding_props?.accent_selection ||
                        developmentData?.branding_props?.accent ||
                        "#F1F1F1"
                    }
                    rounded="2xl"
                    alignContent="center"
                >
                    {!isGreaterThanMd && (
                        <Box
                            bg="white"
                            h="8vh"
                            boxShadow="md"
                            position="fixed"
                            w="full"
                            px={6}
                            py={2}
                            alignContent="center"
                            zIndex={99}
                            top={0}
                        >
                            <Flex gap={4} justifyContent="space-between">
                                <Icon
                                    color={
                                        developmentData?.branding_props?.header_brand ||
                                        developmentData?.branding_props?.brand_text ||
                                        "#C4C4C4"
                                    }
                                    fontSize="4vh"
                                    cursor="pointer"
                                    _hover={{ transform: "scale(1.1)" }}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setShowMenu(true);
                                    }}
                                >
                                    <ListIcon weight="bold" />
                                </Icon>

                                <Image
                                    alt="logo"
                                    src={
                                        developmentData?.branding_props?.logo_header ||
                                        developmentData?.branding_props?.logo
                                    }
                                    maxH="5vh"
                                />

                                <Stack w="4vw" />
                            </Flex>
                        </Box>
                    )}
                    {showMenu && !isGreaterThanMd && (
                        <Stack
                            maxW="52vw"
                            minW="52vw"
                            height="100%"
                            minH="99vh"
                            bg={
                                developmentData?.branding_props?.brand_sidebar ||
                                developmentData?.branding_props?.brand ||
                                "#002B49"
                            }
                            roundedBottomRight="2xl"
                            roundedTopRight="2xl"
                            justifyContent="space-between"
                            align="center"
                            zIndex={1000}
                            position="fixed"
                            top={0}
                            boxShadow="md"
                            left={0}
                            transition="transform 0.3s ease-in-out"
                        >
                            <Stack
                                maxH="60vh"
                                minH="50vh"
                                w="100%"
                                alignItems="end"
                                overflowY={options.length > 3 ? "scroll" : "hidden"}
                                mt={4}
                            >
                                {towersOptions && towersOptions.length > 1 ? (
                                    <Box w="100%">
                                        {towersOptions.map((tower, index) => {
                                            return (
                                                <Accordion.Root collapsible key={index}>
                                                    <Accordion.Item
                                                        key={tower}
                                                        borderTopWidth={index == 0 ? 0 : "0.5px"}
                                                    >
                                                        <Accordion.ItemTrigger
                                                            color={
                                                                developmentData?.branding_props
                                                                    ?.sidebar_brand_text ||
                                                                "#FFFFFF"
                                                            }
                                                            borderTopWidth={
                                                                index == 0 ? 0 : "0.5px"
                                                            }
                                                            borderBottomWidth={
                                                                index == towersOptions.length - 1
                                                                    ? "0.5px"
                                                                    : 0
                                                            }
                                                            borderColor={
                                                                developmentData?.branding_props
                                                                    ?.sidebar_brand_text ||
                                                                "#FFFFFF"
                                                            }
                                                        >
                                                            <Box
                                                                bg="transparent"
                                                                px={6}
                                                                w="100%"
                                                                cursor="pointer"
                                                                m={0}
                                                                mt={0}
                                                                style={{ marginTop: 0 }}
                                                                flex="1"
                                                                textAlign="left"
                                                            >
                                                                <Text
                                                                    color={
                                                                        developmentData
                                                                            ?.branding_props
                                                                            ?.sidebar_brand_text ||
                                                                        "#FFFFFF"
                                                                    }
                                                                    fontSize={
                                                                        developmentData
                                                                            ?.branding_props
                                                                            ?.font_size_sideboard
                                                                            ? developmentData
                                                                                  ?.branding_props
                                                                                  ?.font_size_sideboard
                                                                            : "1.5vh"
                                                                    }
                                                                    fontWeight={700}
                                                                    fontFamily={
                                                                        developmentData
                                                                            ?.branding_props
                                                                            ?.options_font ||
                                                                        developmentData
                                                                            ?.branding_props
                                                                            ?.title_font ||
                                                                        developmentData
                                                                            ?.branding_props
                                                                            .primary_font ||
                                                                        "Montserrat"
                                                                    }
                                                                    textTransform="uppercase"
                                                                    m={0}
                                                                    py={8}
                                                                    maxW="80%"
                                                                >
                                                                    {capitalizeWords(tower)}
                                                                </Text>
                                                            </Box>
                                                            <Accordion.ItemIndicator />
                                                        </Accordion.ItemTrigger>
                                                        <Accordion.ItemContent>
                                                            <Accordion.ItemBody
                                                                p={0}
                                                                borderColor="transparent"
                                                            >
                                                                {options
                                                                    ?.filter(
                                                                        (option) =>
                                                                            option.tower == tower
                                                                    )
                                                                    .map((option, index) => {
                                                                        return (
                                                                            <Box
                                                                                key={
                                                                                    option?.name_option
                                                                                }
                                                                                bg={
                                                                                    developmentData
                                                                                        ?.branding_props
                                                                                        ?.sidebar_brand_text ||
                                                                                    "#FFFFFF"
                                                                                }
                                                                                px={6}
                                                                                w="100%"
                                                                                onClick={(e) => {
                                                                                    e.preventDefault();
                                                                                    setStep(2);
                                                                                    setViewSelected(
                                                                                        option
                                                                                    );
                                                                                    setShowMenu(
                                                                                        false
                                                                                    );
                                                                                }}
                                                                                cursor="pointer"
                                                                                borderTopWidth="0.5px"
                                                                                borderBottomWidth={
                                                                                    index ==
                                                                                    options.length -
                                                                                        1
                                                                                        ? "0.5px"
                                                                                        : 0
                                                                                }
                                                                                borderBottomRadius={
                                                                                    options?.filter(
                                                                                        (option) =>
                                                                                            option.tower ==
                                                                                            tower
                                                                                    ).length ==
                                                                                    index + 1
                                                                                        ? "2xl"
                                                                                        : 0
                                                                                }
                                                                                borderColor="#F1F1F1"
                                                                                m={0}
                                                                                mt={0}
                                                                                style={{
                                                                                    marginTop: 0,
                                                                                }}
                                                                            >
                                                                                <Flex
                                                                                    alignItems="center"
                                                                                    justifyContent="space-between"
                                                                                >
                                                                                    <Text
                                                                                        color={
                                                                                            developmentData
                                                                                                ?.branding_props
                                                                                                ?.brand_sidebar ||
                                                                                            developmentData
                                                                                                ?.branding_props
                                                                                                ?.brand ||
                                                                                            "#002B49"
                                                                                        }
                                                                                        fontSize={
                                                                                            developmentData
                                                                                                ?.branding_props
                                                                                                ?.font_size_sideboard
                                                                                                ? developmentData
                                                                                                      ?.branding_props
                                                                                                      ?.font_size_sideboard
                                                                                                : "1.4vh"
                                                                                        }
                                                                                        fontWeight={
                                                                                            700
                                                                                        }
                                                                                        fontFamily={
                                                                                            developmentData
                                                                                                ?.branding_props
                                                                                                ?.title_font ||
                                                                                            developmentData
                                                                                                ?.branding_props
                                                                                                .primary_font ||
                                                                                            "Montserrat"
                                                                                        }
                                                                                        m={0}
                                                                                        py={8}
                                                                                        maxW="80%"
                                                                                    >
                                                                                        {capitalizeWords(
                                                                                            option?.name_option.replace(
                                                                                                `${tower} /`,
                                                                                                ""
                                                                                            )
                                                                                        )}
                                                                                    </Text>
                                                                                    <Icon
                                                                                        color={
                                                                                            developmentData
                                                                                                ?.branding_props
                                                                                                ?.sidebar_brand_text ||
                                                                                            "#FFFFFF"
                                                                                        }
                                                                                        fontSize={
                                                                                            developmentData
                                                                                                ?.branding_props
                                                                                                ?.font_size_sideboard
                                                                                                ? developmentData
                                                                                                      ?.branding_props
                                                                                                      ?.font_size_sideboard
                                                                                                : "2vh"
                                                                                        }
                                                                                        fontWeight={
                                                                                            700
                                                                                        }
                                                                                    >
                                                                                        <CaretRightIcon />
                                                                                    </Icon>
                                                                                </Flex>
                                                                            </Box>
                                                                        );
                                                                    })}
                                                            </Accordion.ItemBody>
                                                        </Accordion.ItemContent>
                                                    </Accordion.Item>
                                                </Accordion.Root>
                                            );
                                        })}
                                    </Box>
                                ) : (
                                    options.map((option, index) => {
                                        return (
                                            <Box
                                                key={option.name_option}
                                                bg="transparent"
                                                px={6}
                                                w="100%"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setStep(2);
                                                    setViewSelected(option);
                                                    setShowMenu(false);
                                                }}
                                                cursor="pointer"
                                                borderTopWidth={index == 0 ? 0 : "0.5px"}
                                                borderBottomWidth={
                                                    index == options.length - 1 ? "0.5px" : 0
                                                }
                                                borderColor="#F1F1F1"
                                                m={0}
                                                mt={0}
                                                style={{ marginTop: 0 }}
                                            >
                                                <Flex
                                                    alignItems="center"
                                                    justifyContent="space-between"
                                                >
                                                    <Text
                                                        color={
                                                            developmentData?.branding_props
                                                                ?.sidebar_brand_text || "#FFFFFF"
                                                        }
                                                        fontSize={
                                                            developmentData?.branding_props
                                                                ?.font_size_sideboard
                                                                ? developmentData?.branding_props
                                                                      ?.font_size_sideboard
                                                                : "2vh"
                                                        }
                                                        fontWeight={700}
                                                        fontFamily={
                                                            developmentData?.branding_props
                                                                ?.options_font ||
                                                            developmentData?.branding_props
                                                                ?.title_font ||
                                                            developmentData?.branding_props
                                                                .primary_font ||
                                                            "Montserrat"
                                                        }
                                                        textTransform="uppercase"
                                                        m={0}
                                                        py={8}
                                                        maxW="80%"
                                                    >
                                                        {capitalizeWords(option.name_option)}
                                                    </Text>
                                                    <Icon
                                                        color={
                                                            developmentData?.branding_props
                                                                ?.sidebar_brand_text || "#FFFFFF"
                                                        }
                                                        fontSize={
                                                            developmentData?.branding_props
                                                                ?.font_size_sideboard
                                                                ? developmentData?.branding_props
                                                                      ?.font_size_sideboard
                                                                : "2vh"
                                                        }
                                                        fontWeight={700}
                                                    >
                                                        <CaretRightIcon />
                                                    </Icon>
                                                </Flex>
                                            </Box>
                                        );
                                    })
                                )}
                            </Stack>
                            <Stack pb={4}>
                                <Stack align="center" mb={8}>
                                    <Icon
                                        color={
                                            developmentData?.branding_props?.arrow_color_sidebar
                                                ? developmentData?.branding_props
                                                      ?.arrow_color_sidebar
                                                : developmentData?.branding_props?.arrow_color ||
                                                  developmentData?.branding_props
                                                      ?.sidebar_brand_text ||
                                                  developmentData?.branding_props?.brand_text ||
                                                  "#FFFFFF"
                                        }
                                        fontSize="4vh"
                                        cursor="pointer"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setIsInit(false);
                                        }}
                                        _hover={{
                                            color: developmentData?.branding_props?.arrow_color
                                                ? developmentData?.branding_props?.arrow_color
                                                : developmentData?.branding_props
                                                      ?.sidebar_brand_text ||
                                                  developmentData?.branding_props?.accent ||
                                                  "#F1F1F1",
                                            transform: "scale(1.1)",
                                        }}
                                    >
                                        <ArrowLeftIcon />
                                    </Icon>
                                </Stack>
                                <Stack align="center" paddingBottom={1}>
                                    <Text
                                        color={
                                            developmentData?.branding_props
                                                ?.sidebar_copy_brand_text ||
                                            developmentData?.branding_props?.sidebar_brand_text ||
                                            developmentData?.branding_props?.brand_text ||
                                            "#FFFFFF"
                                        }
                                        fontSize="1vh"
                                        fontWeight={400}
                                        paddingBottom={1}
                                    >
                                        Desarrollado por
                                    </Text>
                                    <Image
                                        alt="logo"
                                        src={
                                            developmentData?.branding_props
                                                ?.logo_developer_sidebar ||
                                            developmentData?.branding_props?.logo_developer
                                        }
                                        maxH="10vh"
                                        maxW="25vw"
                                        paddingBottom={1}
                                    />
                                </Stack>
                                <Stack align="center" paddingBottom={1}>
                                    <Text
                                        color={
                                            developmentData?.branding_props
                                                ?.sidebar_copy_brand_text ||
                                            developmentData?.branding_props?.sidebar_brand_text ||
                                            developmentData?.branding_props?.brand_text ||
                                            "#FFFFFF"
                                        }
                                        fontSize="1vh"
                                        fontWeight={400}
                                        paddingBottom={2}
                                    >
                                        Comercializado por
                                    </Text>
                                    <Image
                                        alt="logo"
                                        src={
                                            developmentData?.branding_props?.logo_broker_sidebar ||
                                            "https://media.grupoguia.mx/vision/logo/grupo-guia.svg"
                                        }
                                        maxH="10vh"
                                        maxW="25vw"
                                    />
                                </Stack>
                                <Stack align="center" textAlign="center" pt={4}>
                                    <Text
                                        color={
                                            developmentData?.branding_props
                                                ?.sidebar_copy_brand_text ||
                                            developmentData?.branding_props?.sidebar_brand_text ||
                                            developmentData?.branding_props?.brand_text ||
                                            "#FFFFFF"
                                        }
                                        fontSize="0.8vh"
                                        fontWeight={400}
                                        px={2}
                                    >
                                        Copyright © 2025 © All Rights Reserved - Powered by Grupo
                                        guia
                                        <br />
                                        <Link
                                            href="/Aviso-de-privacidad"
                                            style={{
                                                color:
                                                    developmentData?.branding_props
                                                        ?.sidebar_copy_brand_text ||
                                                    developmentData?.branding_props
                                                        ?.sidebar_brand_text ||
                                                    developmentData?.branding_props?.brand_text ||
                                                    "#FFFFFF",
                                                fontSize: "0.8vh",
                                            }}
                                        >
                                            Aviso de privacidad
                                        </Link>
                                    </Text>
                                </Stack>
                            </Stack>
                        </Stack>
                    )}
                    <Flex>
                        {isGreaterThanMd && (
                            <Stack
                                maxW="12vw"
                                minW="12vw"
                                height="100%"
                                minH="99vh"
                                bg={
                                    developmentData?.branding_props?.brand_sidebar ||
                                    developmentData?.branding_props?.brand ||
                                    "#002B49"
                                }
                                roundedBottomLeft="2xl"
                                roundedTopLeft="2xl"
                                justifyContent="space-around"
                                align="center"
                            >
                                <Image
                                    alt="logo"
                                    src={
                                        developmentData?.branding_props?.logo_sidebar ||
                                        developmentData?.branding_props?.logo
                                    }
                                    maxW="8vw"
                                />

                                <Stack
                                    maxH="50vh"
                                    minH="50vh"
                                    w="100%"
                                    alignItems="end"
                                    gap={2}
                                    overflowY={options.length > 4 ? "scroll" : "hidden"}
                                >
                                    {options.map((option) => {
                                        return (
                                            <Box
                                                key={option.name_option}
                                                bg={
                                                    viewSelected?.name_option == option.name_option
                                                        ? developmentData?.branding_props
                                                              ?.accent_selection ||
                                                          developmentData?.branding_props?.accent ||
                                                          "#F1F1F1"
                                                        : "transparent"
                                                }
                                                py={6}
                                                px={6}
                                                w="90%"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setViewSelected(option);
                                                }}
                                                cursor="pointer"
                                                borderTopLeftRadius="2xl"
                                                borderBottomLeftRadius="2xl"
                                            >
                                                <Text
                                                    color={
                                                        viewSelected?.name_option ==
                                                        option?.name_option
                                                            ? developmentData?.branding_props
                                                                  ?.sidebar_accent_text ||
                                                              developmentData?.branding_props
                                                                  ?.accent_text
                                                            : developmentData?.branding_props
                                                                  ?.sidebar_brand_text ||
                                                              developmentData?.branding_props
                                                                  ?.brand_text ||
                                                              "#FFFFFF"
                                                    }
                                                    fontSize={
                                                        developmentData?.branding_props
                                                            ?.font_size_sideboard
                                                            ? developmentData?.branding_props
                                                                  ?.font_size_sideboard
                                                            : "1.5vh"
                                                    }
                                                    fontWeight={700}
                                                    fontFamily={
                                                        developmentData?.branding_props
                                                            ?.options_font ||
                                                        developmentData?.branding_props
                                                            ?.title_font ||
                                                        developmentData?.branding_props
                                                            .primary_font ||
                                                        "Montserrat"
                                                    }
                                                >
                                                    {capitalizeWords(option.name_option)}
                                                </Text>
                                            </Box>
                                        );
                                    })}
                                </Stack>
                                <Stack>
                                    <Stack align="center" mb={4}>
                                        <Icon
                                            color={
                                                developmentData?.branding_props?.arrow_color_sidebar
                                                    ? developmentData?.branding_props
                                                          ?.arrow_color_sidebar
                                                    : developmentData?.branding_props
                                                          ?.arrow_color ||
                                                      developmentData?.branding_props
                                                          ?.sidebar_brand_text ||
                                                      developmentData?.branding_props?.brand_text ||
                                                      "#FFFFFF"
                                            }
                                            fontSize="4vh"
                                            cursor="pointer"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setIsInit(false);
                                            }}
                                            _hover={{
                                                color: developmentData?.branding_props?.arrow_color
                                                    ? developmentData?.branding_props?.arrow_color
                                                    : developmentData?.branding_props
                                                          ?.sidebar_brand_text ||
                                                      developmentData?.branding_props?.accent ||
                                                      "#F1F1F1",
                                                transform: "scale(1.1)",
                                            }}
                                        >
                                            <ArrowLeftIcon />
                                        </Icon>
                                    </Stack>
                                    <Stack align="center" paddingBottom={1}>
                                        <Text
                                            color={
                                                developmentData?.branding_props
                                                    ?.sidebar_copy_brand_text ||
                                                developmentData?.branding_props
                                                    ?.sidebar_brand_text ||
                                                developmentData?.branding_props?.brand_text ||
                                                "#FFFFFF"
                                            }
                                            fontSize="0.8vh"
                                            fontWeight={400}
                                            paddingBottom={1}
                                        >
                                            Desarrollado por
                                        </Text>
                                        <Image
                                            alt="logo"
                                            src={
                                                developmentData?.branding_props
                                                    ?.logo_developer_sidebar ||
                                                developmentData?.branding_props?.logo_developer
                                            }
                                            maxH="5vh"
                                            maxW="6vw"
                                            paddingBottom={1}
                                        />
                                    </Stack>
                                    <Stack align="center" paddingBottom={1}>
                                        <Text
                                            color={
                                                developmentData?.branding_props
                                                    ?.sidebar_copy_brand_text ||
                                                developmentData?.branding_props
                                                    ?.sidebar_brand_text ||
                                                developmentData?.branding_props?.brand_text ||
                                                "#FFFFFF"
                                            }
                                            fontSize="0.8vh"
                                            fontWeight={400}
                                            paddingBottom={2}
                                        >
                                            Comercializado por
                                        </Text>
                                        <Image
                                            alt="logo"
                                            src={
                                                developmentData?.branding_props
                                                    ?.logo_broker_sidebar ||
                                                "https://media.grupoguia.mx/vision/logo/grupo-guia.svg"
                                            }
                                            maxH="5vh"
                                            maxW="6vw"
                                        />
                                    </Stack>
                                    <Stack align="center" textAlign="center">
                                        <Text
                                            color={
                                                developmentData?.branding_props
                                                    ?.sidebar_copy_brand_text ||
                                                developmentData?.branding_props
                                                    ?.sidebar_brand_text ||
                                                developmentData?.branding_props?.brand_text ||
                                                "#FFFFFF"
                                            }
                                            fontSize="1vh"
                                            fontWeight={400}
                                            px={2}
                                        >
                                            Copyright © 2025 © All Rights Reserved - Powered by
                                            Grupo guia
                                            <br />
                                            <Link
                                                href="/Aviso-de-privacidad"
                                                style={{
                                                    color:
                                                        developmentData?.branding_props
                                                            ?.sidebar_copy_brand_text ||
                                                        developmentData?.branding_props
                                                            ?.sidebar_brand_text ||
                                                        developmentData?.branding_props
                                                            ?.brand_text ||
                                                        "#FFFFFF",
                                                    fontSize: "1vh",
                                                }}
                                            >
                                                Aviso de privacidad
                                            </Link>
                                        </Text>
                                    </Stack>
                                </Stack>
                                <Stack>
                                    {developmentData?.branding_props?.complements?.sidebar &&
                                        developmentData?.branding_props?.complements?.sidebar?.map(
                                            (complement, index) => {
                                                let style_props = {};
                                                Object.keys(complement?.props)?.map((key) => {
                                                    style_props = {
                                                        ...style_props,
                                                        [key]: complement?.props[key],
                                                    };
                                                });
                                                return (
                                                    <Image
                                                        alt="complement"
                                                        src={complement.url}
                                                        style={{ ...style_props }}
                                                        key={index}
                                                    />
                                                );
                                            }
                                        )}
                                </Stack>
                            </Stack>
                        )}
                        <Stack
                            height="100%"
                            minH="99vh"
                            minW={{ base: "99vw", md: "88vw" }}
                            bg={
                                developmentData?.branding_props?.accent_selection ||
                                developmentData?.branding_props?.accent ||
                                "#F1F1F1"
                            }
                            roundedBottomRight="2xl"
                            roundedTopRight="2xl"
                            roundedTopLeft={{ base: "2xl", md: "0" }}
                            roundedBottomLeft={{ base: "2xl", md: "0" }}
                            borderTopRightRadius="2xl"
                            borderBottomRightRadius="2xl"
                            justifyContent="space-around"
                            align="center"
                            onClick={(e) => {
                                e.preventDefault();
                                setShowMenu(false);
                            }}
                        >
                            {developmentData2D ? (
                                <ContentSelection
                                    data={developmentData2D}
                                    options={options}
                                    setOptions={setOptions}
                                    viewSelected={viewSelected}
                                    setViewSelected={setViewSelected}
                                    developmentData={developmentData}
                                    setOptionsTowers={setOptionsTowers}
                                />
                            ) : (
                                <Box display="flex" justifyContent="center">
                                    <Spinner
                                        borderWidth="4px"
                                        animationDuration="0.65s"
                                        emptyColor="gray.200"
                                        color={
                                            developmentData?.branding_props?.brand || "brand.500"
                                        }
                                        size="xl"
                                    />
                                </Box>
                            )}
                        </Stack>
                    </Flex>
                </Box>
            )}
        </>
    );
};

export default Seleccion;
